import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import useCareerInterestStyles from './CareerInterestSubsection.styles';

const CareerInterestInstructions = () => {
  const classedStyles = useCareerInterestStyles();
  return (
    <Grid item xs={12} align="left">
      <Typography variant="body1" className={classedStyles.textAreaFont} style={{ padding: 0, paddingTop: 15 }}>
        Use the questions below to describe your top three career interests. You may refer to your “Planning for My Future” Module 2 – Activities
        workbook for ideas and information.
      </Typography>
      <Typography variant="body1" component="div" className={classedStyles.textAreaFont} style={{ padding: 0, paddingTop: 5, paddingBottom: 0 }}>
        For each career:
        <ul className={classedStyles.textAreaFont} style={{ padding: 0, paddingLeft: 30 }}>
          <li>Type the name of the career you are interested in</li>
          <li>Select the type of education or training it requires from the dropdown menu.</li>
          <li>
            Write <b>two sentences</b> describing the benefits of this career.
          </li>
          <li>
            Write <b>two sentences</b> describing the challenges or downsides.
          </li>
          <li>
            Reflect on why this career stands out to you and explain your interest in <b>no less than two sentences</b>
          </li>
        </ul>
      </Typography>
      <Typography variant="body1" className={classedStyles.textAreaFont} style={{ padding: 0, paddingTop: 0, paddingBottom: 20 }}>
        Be honest and take your time—this activity is about discovering what inspires and motivates you for the future!
      </Typography>
    </Grid>
  );
};

export default CareerInterestInstructions;
